<template v-if="form.id">
    <form
        @submit.prevent="submit"
        method="post"
    >
        <LoadingApp
            :isLoading.sync="isLoading"
            :is_full_page="true"
        />
        <div class="row">
            <div class="col-sm-11">
                <div class="row">
                    <template v-if="form.user_type === 'F'">
                        <div class="col-md-4">
                            <c-form-group class="form-group required-field">
                                <label for="user_company_name">Nome</label>
                                <input type="text" class="form-control" v-model="form.name" id="name" name="name" required/>
                                <div v-if="submitted && !$v.form.name.required && form.user_type === 'J'" class="required">* Nome obrigatório</div>
                            </c-form-group>
                        </div>
                        <div class="col-md-4">
                            <c-form-group class="form-group required-field">
                                <label for="lastname">Sobrenome</label>
                                <input type="text" class="form-control" v-model="form.lastname" id="lastname" name="lastname" required/>
                                <div v-if="submitted && !$v.form.lastname.required && form.user_type === 'J'" class="required">* Sobrenome obrigatório</div>
                            </c-form-group>
                        </div>
                        <div class="col-md-4">
                            <c-form-group class="form-group">
                                <label for="user_birthday">Data de nascimento</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="user_birthday"
                                    :value="form.user_birthday"
                                    v-mask="'##/##/####'"
                                    name="user_birthday"
                                    disabled
                                />
                            </c-form-group>
                        </div>
                        <div class="col-md-4">
                            <c-form-group class="form-group">
                                <label for="user_cpfcnpj">CPF</label>
                                <input type="text" class="form-control" :value="form.user_cpfcnpj" id="user_cpfcnpj" name="user_cpfcnpj" disabled  style="background-color: #e3e3e3 !important; opacity: 0.8;"/>
                            </c-form-group>
                        </div>
                    </template>
                    <template v-if="form.user_type === 'J'">
                        <div class="col-md-4">
                            <c-form-group class="form-group required-field">
                                <label for="user_fantasy_name">Nome fantasia</label>
                                <input type="text" class="form-control" v-model="form.user_fantasy_name" id="user_fantasy_name" name="user_fantasy_name"/>
                                <div v-if="submitted && !$v.form.user_fantasy_name.required" class="required">* Nome fantasia obrigatório</div>
                            </c-form-group>
                        </div>
                        <div class="col-md-4">
                            <c-form-group class="form-group required-field">
                                <label for="user_company_name">Razão sozial</label>
                                <input type="text" class="form-control" v-model="form.user_company_name" id="user_company_name" name="user_company_name"/>
                                <div v-if="submitted && !$v.form.user_company_name.required && form.user_type === 'J'" class="required">* Razão social obrigatório</div>
                            </c-form-group>
                        </div>
                        <div class="col-md-4">
                            <c-form-group class="form-group">
                                <label for="user_cpfcnpj">CNPJ</label>
                                <input type="text" class="form-control" :value="form.user_cpfcnpj" id="user_cpfcnpj" name="user_cpfcnpj" disabled  style="background-color: #e3e3e3 !important; opacity: 0.8;"/>
                            </c-form-group>
                        </div>
                        <div class="col-md-8">
                            <c-form-group class="form-group">
                                <label for="user_ie">Inscrição estadual</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="user_ie"
                                    name="user_ie"
                                    v-model="form.user_ie"
                                    :readonly="form.user_isento"
                                    :disabled="form.user_isento"
                                />
                                <div v-if="submitted && !$v.form.user_ie.required" class="required">* Inscrição estadual obrigatório</div>
                            </c-form-group>
                        </div>
                        <div class="col-md-4">
                            <c-form-group class="form-group">
                                <label>Isento</label>
                                <input type="checkbox" class="form-control" style="display:none;" id="user_isento" v-model="form.user_isento"  name="user_isento">
                                <ul class="config-swatch-list">
                                    <li @click="checkIsento(form.user_isento);" id="li_isento" :class="[form.user_isento ? 'inputIsentoChecked': '', 'active input_checkbox']" >
                                        <a></a>
                                    </li>
                                </ul>
                            </c-form-group>
                        </div>
                    </template>
                    <div class="col-md-4">
                        <c-form-group class="form-group required-field">
                            <label for="email">Email</label>
                            <input type="email" class="form-control" v-model="form.email" id="email" name="email" disabled style="background-color: #e3e3e3 !important; opacity: 0.8;"/>
                        </c-form-group>
                    </div>
                    <div class="col-md-4">
                        <c-form-group class="form-group">
                            <label for="phone">Telefone</label>
                            <input
                                type="phone"
                                class="form-control"
                                v-model="form.phone"
                                v-mask="maskPhone(form.phone)"
                                id="phone"
                                name="phone"
                            />
                        </c-form-group>
                    </div>
                    <div class="col-md-4">
                        <c-form-group class="form-group">
                            <label for="phone_number">Celular</label>
                            <input
                                type="phone_number"
                                class="form-control"
                                v-model="form.phone_number"
                                v-mask="maskPhone(form.phone_number)"
                                id="phone_number"
                                name="phone_number"
                            />
                        </c-form-group>
                    </div>
                    <template v-if="form.user_type === 'J'">
                        <div class="col-md-4">
                            <c-form-group class="form-group">
                                <label for="responsible_name">Nome do responsável</label>
                                <input
                                    type="responsible_name"
                                    class="form-control"
                                    v-model="form.responsible_name"
                                    id="responsible_name"
                                    name="responsible_name"
                                />
                            </c-form-group>
                        </div>
                        <div class="col-md-4">
                            <c-form-group class="form-group">
                                <label for="responsible_cpf">CPF do responsável</label>
                                <input
                                    type="responsible_cpf"
                                    class="form-control"
                                    v-model="form.responsible_cpf"
                                    id="responsible_cpf"
                                    name="responsible_cpf"
                                />
                            </c-form-group>
                        </div>
                    </template>
                    <div class="col-12">
                        <c-form-group class="form-group">
                            <div class="d-flex align-items-center">
                                <input
                                    type="checkbox"
                                    class="form-input form-wide required"
                                    id="user_newsletter"
                                    v-model="form.user_newsletter"
                                    name="user_newsletter"
                                    style="width:20px;margin-right:5px"
                                />
                                <label for="user_newsletter" class="m-0">
                                    Quero receber ofertas e novidades por e-mail
                                </label>
                            </div>
                        </c-form-group>
                    </div>
                </div>
            </div>
        </div>

        <div class="mb-2"></div>

        <div class="custom-control custom-checkbox">
            <input
                type="checkbox"
                class="custom-control-input"
                v-model="form.update_password"
                @change="updatePassword(form.update_password)"
                id="change-pass-checkbox"
                value="1"
            >
            <c-label
                class="custom-control-label"
                for="change-pass-checkbox"
                style="margin-left:15px;"
            >
                Alterar senha
            </c-label>
        </div>

        <div id="account-chage-pass">
            <c-heading-3 class="mb-2">Alterar senha</c-heading-3>
            <div class="row">
                <div class="col-md-6">
                    <c-form-group class="form-group required-field">
                        <label for="current_password">Senha atual</label>
                        <input
                            type="password"
                            class="form-control"
                            id="current_password"
                            name="current_password"
                            v-model="form.current_password"
                        />
                        <div v-if="submitted && !$v.form.current_password.required" class="required">* Senha atual obrigatório</div>
                    </c-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <c-form-group class="form-group required-field">
                        <label for="password">Nova senha</label>
                        <input
                            type="password"
                            class="form-control"
                            id="password"
                            name="password"
                            v-model="form.password"
                        />
                        <div v-if="submitted && !$v.form.password.required" class="required">* Nova senha obrigatório</div>
                        <div v-else-if="submitted && !$v.form.password.minLength" class="required"> A nova senha precisa ter no mínimo 6 caracteres </div>
                    </c-form-group>
                </div>

                <div class="col-md-6">
                    <c-form-group class="form-group required-field">
                        <label for="password_confirmation">Confirmar nova senha</label>
                        <input
                            type="password"
                            class="form-control"
                            id="password_confirmation"
                            name="password_confirmation"
                            v-model="form.password_confirmation"
                        />
                        <div v-if="submitted && !$v.form.password_confirmation.required" class="required">* Confirmação da senha obrigatório</div>
                        <div v-else-if="submitted && !$v.form.password_confirmation.sameAsPassword" class="required">As senhas precisam ser idênticas</div>
                    </c-form-group>
                </div>
            </div>
        </div>

        <div class="required text-right">* Campos Obrigatórios</div>
        <div class="form-footer">
            <c-link :href="urlprevious"><i class="icon-angle-double-left"></i>Voltar</c-link>

            <div class="form-footer-right">
                <c-button
                    :backgroundColor="$root.$children[0].theme.products.button.background_color"
                    :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                    :color="$root.$children[0].theme.products.button.color"
                    :colorHover="$root.$children[0].theme.products.button.color_hover"
                    :borderColor="$root.$children[0].theme.products.button.border_color"
                    :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                    :borderRadius="$root.$children[0].theme.products.button.border_radius"
                    type="submit"
                    margin="0"
                    :textTransform="$root.$children[0].theme.products.button.text_transform"
                    height="unset"
                    :fontSize="$root.$children[0].theme.font_size_button"
                    minWidth="124px"
                    padding="1rem 2rem"
                    display="inline-block"
                    textAlign="center"
                    lineHeight="1.5"
                    letterSpacing=".1rem"
                    transition="all .3s"
                >
                    Salvar
                </c-button>
            </div>
        </div>
    </form>
</template>

<script>
import { required, minLength, requiredIf, sameAs, email, validateIf } from 'vuelidate/lib/validators'
import  { mapActions } from 'vuex'
import LoadingApp from '../../components/LoadingApp'
import { CButton } from '../../components/Styles/Button/styled'
import { CFormGroup, CHeading3, CLabel, CLink } from '../../components/Styles/Components/styled'

export default {
    name: 'EditAccountForm',
    components: {
        LoadingApp,
        'c-button': CButton,
        'c-form-group': CFormGroup,
        'c-label': CLabel,
        'c-heading-3': CHeading3,
        'c-link': CLink
    },
    props: {
        user:{required:true},
        urlprevious:{default:null}
    },
    data() {
        return {
            isLoading: false,
            form: {
                ...this.user.data,
                ...this.user?.address,
                name: null,
                lastname:'',
                current_password: null,
                password: null,
                password_confirmation: null,
                update_password: false,
            },
            submitted: false
        }
    },
    created() {
        this.setNameAndLastName(this.user.data)
    },
    validations: {

        form: {
            user_fantasy_name: {required: requiredIf(function(val) {
                return this.form.user_type === 'J'
            })},
            user_company_name: {
                required: requiredIf(function(val) {
                    return this.form.user_type === 'J'
                })
            },
            name: {
                required: requiredIf(function(val) {
                    return this.form.user_type === 'F'
                })
            },
            lastname: {
                required: requiredIf(function(val) {
                    return this.form.user_type === 'F'
                })
            },
            user_ie: {
                required: requiredIf(function(val) {
                    return this.form.user_type === 'J' && this.form.user_isento === false
                })
            },
            current_password:{
                required: requiredIf(function(val) {
                    return this.form.update_password === true
                })
            },
            password:{
                required: requiredIf(function(val, model) {
                    return this.form.update_password === true
                }),
                minLength: minLength(6)
            },
            password_confirmation:{
                required: requiredIf(function(val) {
                    return this.form.update_password === true
                }),
                sameAsPassword: sameAs('password')
            },
        }
    },
    methods: {
        ...mapActions("account", [
            "ActionUpdateAccount"
        ]),
        maskPhone(phone) {
            if(phone?.length == 14) {
                return '(##) ####-####'
            } else {
                return '(##) #####-####'
            }
        },
        async submit() {
            this.isLoading = true
            this.submitted = true
            if (this.$v.$invalid) {
                this.isLoading = false
                this.$v.form.$touch()
                return
            }
            await this.sendData()
            this.isLoading = false
        },
        updatePassword() {
            return this.form.update_password
        },
        setValidator(validator) {
            let errors = ''
            for (var [key, value] of Object.entries(validator)) {
                errors += '* '+value+'\n'
            }
            alert(errors)
        },
        async sendData() {
            await this.ActionUpdateAccount(this.form)
            .then(async (resp) => {
                this.submitted = false
                this.$v.$reset()
                this.resetPassword()
                alert('SUCESSO! \n Seus dados foram alterados.')
                return true
            })
            .catch((error) => {
                if(error.msg || error.validator) {
                    if(error.validator) {
                        this.setValidator(error.validator)
                        return
                    }
                    alert(error.msg)
                    return
                }
                alert(error)
            })
        },
        resetPassword() {
            this.form.current_password = null
            this.form.password = null
            this.form.password_confirmation = null
        },
        checkIsento(isento) {
            if(isento === false) {
                this.form.user_isento = true
                this.form.user_ie = null
                return
            }
            this.form.user_isento = false
            this.form.user_ie = null
        },
        updatePassword(state) {
            if(!state) {
                this.$v.$reset()
                this.resetPassword()
            }
        },
        setNameAndLastName(user)
        {
            if(user.user_type == 'F') {
                let data = user.user_company_name.split(' ')
                this.form.name = data[0]
                for(let index in data) {
                    if(index > 0) {
                        this.form.lastname += data[index]+" "
                    }
                }
            }
        }
    }
}
</script>

<style scoped>
.inputIsentoChecked {
    background-color: #EDE56A;
}
</style>
